<template>
  <div :class="$style.container">
    <div :class="$style.form">
      <div :class="$style.logo">
        <img src="/icons/common/logo.svg" alt="" />
      </div>
      <CommonSelect
        placeholder="Выбор организации"
        :hints="organizations"
        @setHint="(hint) => (organization = hint)"
      />
      <CommonSelect
        placeholder="Выбор работника"
        :hints="users"
        :disabled="!organization"
        @setHint="(hint) => (worker = hint)"
      />
      <!-- <div>
        <input
          v-model="name"
          placeholder="Введите название наблюдения"
          type="text"
          :class="$style.input"
        />
      </div> -->
      <div @click="start">
        <div :class="$style.button">Начать наблюдение</div>
      </div>
      <div v-if="error" :class="$style.error">
        <p>{{ error }}</p>
        <div @click="open">Перейти к текущему</div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonSelect from "@/components/common/CommonSelect.vue";
import Repository from "@/repository";
import getLastSupervision from "@/mixins/getLastSupervision";
export default {
  mixins: [getLastSupervision],
  components: {
    CommonSelect,
  },
  data() {
    return {
      organizations: [],
      users: [],
      organization: "",
      worker: "",
      name: null,
      error: "",
    };
  },
  async mounted() {
    this.$store.commit("setLoadersCount", "+");
    await this.fethcOrganizations();
    await this.fethcUsers();
    this.$store.commit("setLoadersCount", "-");
  },
  methods: {
    async start() {
      if (this.organization && this.worker) {
        this.$store.commit("setLoadersCount", "+");
        const { value, error } = await Repository.Supervision.create({
          organization: this.organization,
          worker: this.worker,
          name: this.name,
        });
        this.$store.commit("setLoadersCount", "-");

        if (value) {
          this.$store.commit("stopTimer");
          this.$router.push(`/ticker/${value.id}`);
        }
      }
    },
    async fethcOrganizations() {
      const { value, error } = await Repository.Organizations.get();
      if (value) {
        value.forEach((i) => {
          this.organizations.push({ slug: i.id, title: i.name });
        });
      }
    },
    async fethcUsers() {
      const params = {
        only_workers: true,
      };
      const { value, error } = await Repository.Users.get(params);
      if (value) {
        value.forEach((i) => {
          this.users.push({ slug: i.id, title: i.username });
        });
      }
    },
    // async open() {
    //   const id = await this.$store.dispatch("getOpenSupervision");
    //   if (id) {
    //     this.$router.push(`/ticker/${id}`);
    //   }
    // },
  },
};
</script>

<style lang="scss" module>
.container {
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  .form {
    max-width: 320px;

    .logo {
      font-weight: 700;
      font-size: 1.5rem;
      text-align: center;
      margin: 0 0 1.5rem 0;
    }
    .input {
      font-weight: 400;
      font-size: 1rem;
      width: 100%;
      padding: 1rem;
      outline: 0;
      border: none;
      border-radius: 0.25rem;
      margin: 0 0 1rem 0;
      &:last-child {
        margin: 0 0 1.5rem 0;
      }
    }
    .button {
      font-weight: 700;
      background-color: $black;
      padding: 0.75rem;
      text-align: center;
      color: $t-white;
      border-radius: 0.5rem;
      cursor: pointer;
    }
    .error {
      color: red;
      text-align: center;
      font-size: 0.875rem;
      margin: 0.5rem 0 0 0;
      div {
        text-decoration: underline;
        margin: 0.25rem 0 0 0;
        color: $black;
        cursor: pointer;
      }
    }
  }
}
</style>
